import React from 'react';

const Error = () => {
    return (
        <div className="info-box">No bundles to compare. Add at least two bundles to compare. <a href="/bundles" className="underline">Back to bundles List.</a></div>
    )
};

export default Error;